module.exports = __webpack_public_path__ + "static/media/original(4).c9136793.webp";